import React from "react";
import "../styles/AboutUsPage.css"; // Import your CSS
import person1 from "../assets/images/person1.png";
import person2 from "../assets/images/person2.png";
import person3 from "../assets/images/person3.png";
import person4 from "../assets/images/person4.png";
import { useNavigate } from "react-router-dom";
import bhrigu_logo from "../assets/images/bhrigu-logo.gif";

const AboutUsPage = () => {
    const navigate = useNavigate();
    return (
        <div className="aboutuspage">
            <div className="wrap">
                {/* Left Sidebar */}
                <aside className="side-left"></aside>

                {/* Main Profiles */}
                <main className="main">
                    <div className="profiles">
                        {/* Profile 1 */}
                        <div className="profile">
                            <img src={person1} alt="Profile 1" />
                            <p>
                                A seasoned media professional with 38 years of experience in conglomerates
                                like The Times of India, Rajasthan Patrika, Divya Bhaskar, India Today,
                                Mens Health and Ministry of Information and Broadcasting (PIB)
                            </p>
                        </div>

                        {/* Profile 2 */}
                        <div className="profile" alt="Profile 2">
                            <img src={person2} />
                            <p>
                                A multi-talented professional with 30 years of experience in teaching and textile
                                industry. Running her FB page “Rajasthan Crafts” successfully for years. Now venturing
                                into the digital and social media with Bhrigu Lineage.
                            </p>
                        </div>

                        {/* Profile 3 */}
                        <div className="profile">
                            <img src={person3} alt="Profile 3" />
                            <p>
                                Dr. Kriti Bhargava is a Psychologist with over 8 years of professional experience in counseling,
                                teaching, and research. She currently serves as an Assistant Professor in the Department of Psychology
                                at Christ University, Bangalore. With a residency in Canada, Dr. Bhargava brings a global perspective to
                                her academic and work, integrating cross-cultural insights into her teaching and practice.
                            </p>
                        </div>

                        {/* Profile 4 */}
                        <div className="profile">
                            <img src={person4} alt="Profile 4" />
                            <p>
                                Naman Bhargava is a lawyer with a strong academic background in law and global business management.
                                He holds an advanced degree in Global Business Management from Canada. Currently working and settled
                                in Canada, he brings a multidisciplinary approach to his profession, bridging law and business in a
                                global context. profession, bridging law and business in a global context.
                            </p>
                        </div>
                    </div>
                </main>

                {/* Right Sidebar */}
                <aside className="side-right">
                    <div>
                        <button className="home" onClick={() => navigate("/dashboard")}>Home</button>
                    </div>

                    {/* <div id="nextbtn">
                            <a href="">
                              <input
                                type="submit"
                                value="HOME"
                                onClick={() => navigate("/dashboard")}
                              />
                            </a>
                          </div> */}
                    <div className="logo-section">
                        <div>
                            <img
                                src={bhrigu_logo}
                                alt="Bhrigu Logo"
                            />
                        </div>
                    </div>
                    <div className="contact">
                        <h3>Contact us :</h3>
                        <p>
                            A-801, 8th Floor
                            <br />
                            Antriksh Golf View 2,
                            <br />
                            Sector-78,
                            <br />
                            Noida - 201306
                            <br />
                            Uttar Pradesh
                            <br />
                            bhrigulineage@gmail.com
                            <br />
                            9810420015
                        </p>
                    </div>
                </aside>
            </div>
        </div>
    );
};

export default AboutUsPage;
